import { roundTo } from "../utils/mathUtils";
import {
  playerCol,
  teamCol,
  confCol,
  yearCol,
  divCol,
  classCol,
  throwsCol,
  numCol,
  round1Col,
  round2Col,
  round0Col,
  pctColWithSort,
  warCol,
  sosAdjWarCol,
} from "./leaderboards/helpers";

const pitchingRecordStats = [
  numCol("W", "w", "4rem"),
  numCol("L", "l", "4rem"),
  numCol("SV", "sv", "4rem"),
  numCol("GS", "gs", "4rem"),
  numCol("APP", "app", "5rem"),
  round1Col("IP", "ip", "5rem"),
  numCol("BF", "bf", "4rem"),
];

const pitchingAllowedStats = [
  numCol("H", "h", "4rem"),
  numCol("R", "r", "4rem"),
  numCol("ER", "er", "4rem"),
  numCol("BB", "bb", "4rem"),
  numCol("SO", "so", "4rem"),
  numCol("HBP", "hbp", "5rem"),
  numCol("HR", "hr_a", "4rem"),
  numCol("2B", "2b_a", "4rem"),
  numCol("3B", "3b_a", "4rem"),
];

const pitchingEraStats = [
  round2Col("ERA", "era", "5rem"),
  round2Col("RA9", "ra9", "5rem"),
  round0Col("ERA+", "era_plus", "5rem"),
];

const pitchingFipStats = [
  round2Col("FIP", "fip", "5rem"),
  round2Col("xFIP", "xfip", "5rem"),
];

const pitchingRateStats = [
  round2Col("K/9", "k9", "5rem"),
  round2Col("BB/9", "bb9", "5rem"),
  round2Col("HR/9", "hr9", "5rem"),
  round2Col("H/9", "h9", "5rem"),
];

const pitchingAdvanced = [
  pctColWithSort("K%", "k_pct"),
  pctColWithSort("BB%", "bb_pct"),
  pctColWithSort("K-BB%", "k_minus_bb_pct", "6rem"),
  pctColWithSort("HR/FB", "hr_div_fb", "6rem"),
    {
      name: "GMLI",
      selector: (row) => row.gmli,
      sortable: true,
      width: "5rem",
    className: "text-center",
      cell: (row) => row.gmli === 0 ? '-' : roundTo(row.gmli, 2),
    },
];

const pitchingValue = [
  round1Col("Clutch", "clutch", "6rem"),
  round1Col("pWPA", "pwpa", "6rem"),
  round1Col("pWPA/LI", "pwpa_li", "7rem"),
  round1Col("pREA", "prea", "6rem"),
];

const pitchingOther = [
  numCol("GO", "go", "4rem"),
  numCol("FO", "fo", "4rem"),
];

export function getPitchingColumns(forStatTable = false) {
  const playerColumn = forStatTable
    ? { name: "Player", selector: (row) => row.player_name, sortable: true, width: "10rem" }
    : playerCol();

  return [
    playerColumn,
    teamCol("10rem"),
    confCol(),
    divCol(),
    yearCol(),
    classCol(),
    throwsCol(),
    ...pitchingRecordStats,
    ...pitchingAllowedStats,
    ...pitchingEraStats,
    ...pitchingFipStats,
    ...pitchingRateStats,
    ...pitchingAdvanced,
    ...pitchingValue,
    warCol("5rem"),
    sosAdjWarCol("8rem"),
    ...pitchingOther,
  ];
}
